import React from 'react';
import { Field } from 'formik';

import styles from './tagsFormGroupStyles';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';

import CaretRightIcon from 'buyside/svgs/caret_right.svg';

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

class TagsFormGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: Boolean(props.numSelected) };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  toggleExpanded() {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { tagGroup, numSelected } = this.props;
    const { expanded } = this.state;
    return (
      <div className={styles.tagsFormGroup}>
        <div className={styles.tagsFormGroupHeader} onClick={this.toggleExpanded}>
          <span className={styles.tagsFormGroupHeaderSection}>
            <CaretRightIcon className={`${styles.caret} ${expanded && styles.expanded}`} />
            <span>
              {tagGroup.name}
              {!expanded && <span className={styles.tagsFormSubtitle}>- Click to expand</span>}
            </span>
          </span>
          <span>{numSelected} selected</span>
        </div>
        <div>
          {expanded &&
            tagGroup.subgroups.map((subgroup, subIdx) => {
              return (
                <div key={subIdx} className={styles.tagsFormSubgroup}>
                  <div className={styles.tagsFormSubgroupHeader}>
                    {subgroup.name}
                    {subgroup.restriction && (
                      <span className={styles.tagsFormSubtitle}>
                        <em>(Limit 1 selectable)</em>
                      </span>
                    )}
                  </div>
                  <div className={styles.tagsFormSubgroupCheckboxes}>
                    <Field
                      component={CheckboxesField}
                      name="fundProfile.tagNames"
                      options={subgroup.tags.map(({ name }) => name)}
                      numColumns={2}
                      restriction={subgroup.restriction}
                    />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default TagsFormGroup;
